import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-jakarta\",\"display\":\"swap\"}],\"variableName\":\"jakarta\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Big_Shoulders\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":\"variable\",\"variable\":\"--font-big-shoulders\",\"display\":\"swap\",\"adjustFontFallback\":false}],\"variableName\":\"bigShoulders\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/GardenAtmosphere.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GardenAtmosphereProvider"] */ "/vercel/path0/src/components/GardenAtmosphereProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/GardenChatCorner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/NavBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegister"] */ "/vercel/path0/src/components/ServiceWorkerRegister.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SuppressThreeWarnings"] */ "/vercel/path0/src/components/SupressThreeWarnings.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/src/components/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebMcpProvider"] */ "/vercel/path0/src/components/WebMcpProvider.tsx");
